import React, { useState } from 'react'
import logo from '../images/logo.svg'
import logo3 from '../images/logo3.svg'
import icon from "../images/icon.svg"
import { Link, useLocation } from 'react-router-dom'


function SideNav() {
  const path = useLocation().pathname
  const [chart, setchart] = useState(false)
  const [isform, setisform] = useState(false)
  const [istables, setistables] = useState(false)
  const [mailbox, setmailbox] = useState(false)
  const [pages, setpages] = useState(false)
  const [Extras, setExtras] = useState(false)




  return (
    <div>
       <aside className="main-sidebar sidebar-dark-primary elevation-4">
        <div className="brand-link navbar-white">
            <Link to="/"  >
              <img src={icon} alt="Logo" className="brand-image "  />
              {/* <img src={logo3} alt="Logo" className=" " style={{width:135,backgroundColor:"red"}}  /> */}
              <span className="brand-text font-weight-bold" style={{color:"#214084",fontSize:30,lineHeight:0.8,marginTop:-8,maxHeight:33}}>SCANIYA</span>
            </Link>
        </div>
        
       
        <div className="sidebar">
          {/* Sidebar user panel (optional) */}
          <div className="user-panel mt-3 pb-3 mb-3 d-flex">
            <div className="image">
              <img src="dist/img/user2-160x160.jpg" className="img-circle elevation-2" alt="User Image" />
            </div>
            <div className="info">
              <Link to="#" className="d-block" style={{color:"#fff"}}>Vikas Panchal</Link>
              <Link style={{color:"#ccc",fontSize:13}}>admin@testmail.com</Link>
            </div>
          </div>
          {/* SidebarSearch Form */}
          <div className="form-inline">
            <div className="input-group" data-widget="sidebar-search">
              <input className="form-control form-control-sidebar" type="search" placeholder="Search" aria-label="Search" />
              <div className="input-group-append">
                <button className="btn btn-sidebar">
                  <i className="fas fa-search fa-fw" />
                </button>
              </div>
            </div>
          </div>
          {/* Sidebar Menu */}
          <nav className="mt-2">
            <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
              {/* Add icons to the links using the .nav-icon class
               with font-awesome or any other icon font library */}
              <li className="nav-item">
                <Link to="/dashboard" className={`nav-link ${path === "/dashboard"? "active" : null}`}>
                  <i className="nav-icon fas fa-tachometer-alt" />
                  <p>
                    Dashboard                    
                  </p>
                </Link>
                {/* <ul className="nav nav-treeview">
                  <li className="nav-item">
                    <Link to="./index.html" className="nav-link active">
                      <i className="far fa-circle nav-icon" />
                      <p>Dashboard v1</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="./index2.html" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Dashboard v2</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="./index3.html" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Dashboard v3</p>
                    </Link>
                  </li>
                </ul> */}
              </li>
              <li className="nav-item">
                <Link to="/widgets" className={`nav-link ${path === "/widgets"? "active" : null}`}>
                  <i className="nav-icon fas fa-th" />
                  <p>
                    Widgets
                    <span className="right badge badge-danger">New</span>
                  </p>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/chat" className={`nav-link ${path === "/chat"? "active" : null}`}>
                  <i className="nav-icon fas fa-th" />
                  <p>
                    Chats
                    <span className="right badge badge-danger">New</span>
                  </p>
                </Link>
              </li>
              {/* <li className="nav-item">
                <Link to="#" className="nav-link">
                  <i className="nav-icon fas fa-copy" />
                  <p>
                    Layout Options
                    <i className="fas fa-angle-left right" />
                    <span className="badge badge-info right">6</span>
                  </p>
                </Link>
                <ul className="nav">
                  <li className="nav-item">
                    <Link to="/test" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Top Navigation</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Top Navigation + Sidebar</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Boxed</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Fixed Sidebar</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Fixed Sidebar <small>+ Custom Area</small></p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Fixed Navbar</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Fixed Footer</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Collapsed Sidebar</p>
                    </Link>
                  </li>
                </ul>
              </li> */}
              <li className="nav-item">
                <Link to="#" className="nav-link" onClick={()=>setchart(!chart)}>
                  <i className="nav-icon fas fa-chart-pie" />
                  <p>
                    Charts
                    <i className="right fas fa-angle-left" />
                  </p>
                </Link>
                {chart && 
                <ul className="nav">
                  <li className="nav-item">
                    <Link to="/charts" className={`nav-link ${path === "/charts"? "active" : null}`}>
                      <i className="far fa-circle nav-icon" />
                      <p>ChartJS</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/flot" className={`nav-link ${path === "/flot"? "active" : null}`}>
                      <i className="far fa-circle nav-icon" />
                      <p>Flot</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/inline" className={`nav-link ${path === "/inline"? "active" : null}`}>
                      <i className="far fa-circle nav-icon" />
                      <p>Inline</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/uplot" className={`nav-link ${path === "/uplot"? "active" : null}`}>
                      <i className="far fa-circle nav-icon" />
                      <p>uPlot</p>
                    </Link>
                  </li>
                </ul>}
              </li>
              {/* <li className="nav-item">
                <Link to="#" className="nav-link">
                  <i className="nav-icon fas fa-tree" />
                  <p>
                    UI Elements
                    <i className="fas fa-angle-left right" />
                  </p>
                </Link>
                <ul className="nav">
                  <li className="nav-item">
                    <Link to="/" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>General</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Icons</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Buttons</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Sliders</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Modals &amp; Alerts</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Navbar &amp; Tabs</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Timeline</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Ribbons</p>
                    </Link>
                  </li>
                </ul>
              </li> */}
              <li className="nav-item">
                <Link to="#" className="nav-link" onClick={()=>setisform(!isform)}>
                  <i className="nav-icon fas fa-edit" />
                  <p>
                    Forms
                    <i className="fas fa-angle-left right" />
                  </p>
                </Link>
                {isform && 
                <ul className="nav">
                  <li className="nav-item">
                    <Link to="/" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>General Elements</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Advanced Elements</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Editors</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Validation</p>
                    </Link>
                  </li>
                </ul>}
              </li>
              <li className="nav-item">
                <Link to="#" className="nav-link" onClick={()=>setistables(!istables)}>
                  <i className="nav-icon fas fa-table" />
                  <p>
                    Tables
                    <i className="fas fa-angle-left right" />
                  </p>
                </Link>
                {istables && 
                <ul className="nav">
                  <li className="nav-item">
                    <Link to="/table-simple" className={`nav-link ${path === "/table-simple"? "active" : null}`}>
                      <i className="far fa-circle nav-icon" />
                      <p>Simple Tables</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/table-datas" className={`nav-link ${path === "/table-datas"? "active" : null}`}>
                      <i className="far fa-circle nav-icon" />
                      <p>DataTables</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/table-jsgrid" className={`nav-link ${path === "/table-jsgrid"? "active" : null}`}>
                      <i className="far fa-circle nav-icon" />
                      <p>jsGrid</p>
                    </Link>
                  </li>
                </ul>}
              </li>
              <li className="nav-header">EXAMPLES</li>
              <li className="nav-item">
                <Link to="/calendar" className={`nav-link ${path === "/calendar"? "active" : null}`}>
                  <i className="nav-icon far fa-calendar-alt" />
                  <p>
                    Calendar
                    <span className="badge badge-info right">2</span>
                  </p>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/gallery" className={`nav-link ${path === "/gallery"? "active" : null}`}>
                  <i className="nav-icon far fa-image" />
                  <p>
                    Gallery
                  </p>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/kanban" className={`nav-link ${path === "/kanban"? "active" : null}`}>
                  <i className="nav-icon fas fa-columns" />
                  <p>
                    Kanban Board
                  </p>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="#" className="nav-link" onClick={()=>setmailbox(!mailbox)}>
                  <i className="nav-icon far fa-envelope" />
                  <p>
                    Mailbox
                    <i className="fas fa-angle-left right" />
                  </p>
                </Link>
                {mailbox && 
                <ul className="nav">
                  <li className="nav-item">
                    <Link to="/mailbox" className={`nav-link ${path === "/mailbox"? "active" : null}`}>
                      <i className="far fa-circle nav-icon" />
                      <p>Inbox</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/mail-compose" className={`nav-link ${path === "/mail-compose"? "active" : null}`}>
                      <i className="far fa-circle nav-icon" />
                      <p>Compose</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/mail-read" className={`nav-link ${path === "/mail-read"? "active" : null}`}>
                      <i className="far fa-circle nav-icon" />
                      <p>Read</p>
                    </Link>
                  </li>
                </ul>}
              </li>
              <li className="nav-item">
                <Link to="#" className="nav-link" onClick={()=>setpages(!pages)}>
                  <i className="nav-icon fas fa-book" />
                  <p>
                    Pages
                    <i className="fas fa-angle-left right" />
                  </p>
                </Link>
                {pages && 
                <ul className="nav">
                  <li className="nav-item">
                    <Link to="/invoice" className={`nav-link ${path === "/invoice"? "active" : null}`}>
                      <i className="far fa-circle nav-icon" />
                      <p>Invoice</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/profile" className={`nav-link ${path === "/profile"? "active" : null}`}>
                      <i className="far fa-circle nav-icon" />
                      <p>Profile</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/e-commerce" className={`nav-link ${path === "/e-commerce"? "active" : null}`}>
                      <i className="far fa-circle nav-icon" />
                      <p>E-commerce</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/projects" className={`nav-link ${path === "/projects"? "active" : null}`}>
                      <i className="far fa-circle nav-icon" />
                      <p>Projects</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/project-add" className={`nav-link ${path === "/project-add"? "active" : null}`}>
                      <i className="far fa-circle nav-icon" />
                      <p>Project Add</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/project-edit" className={`nav-link ${path === "/project-edit"? "active" : null}`}>
                      <i className="far fa-circle nav-icon" />
                      <p>Project Edit</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/project-detail" className={`nav-link ${path === "/project-detail"? "active" : null}`}>
                      <i className="far fa-circle nav-icon" />
                      <p>Project Detail</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/contacts" className={`nav-link ${path === "/contacts"? "active" : null}`}>
                      <i className="far fa-circle nav-icon" />
                      <p>Contacts</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/faq" className={`nav-link ${path === "/faq"? "active" : null}`}>
                      <i className="far fa-circle nav-icon" />
                      <p>FAQ</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/contact-us" className={`nav-link ${path === "/contact-us"? "active" : null}`}>
                      <i className="far fa-circle nav-icon" />
                      <p>Contact us</p>
                    </Link>
                  </li>
                </ul>}
              </li>
              <li className="nav-item">
                <Link to="#" className="nav-link" onClick={()=>setExtras(!Extras)}>
                  <i className="nav-icon far fa-plus-square" />
                  <p>
                    Extras
                    <i className="fas fa-angle-left right" />
                  </p>
                </Link>
                {Extras && 
                <ul className="nav">
                  <li className="nav-item">
                    <Link to="#" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>
                        Login &amp; Register
                        <i className="fas fa-angle-left right" />
                      </p>
                    </Link>
                    <ul className="nav nav-treeview">
                      <li className="nav-item">
                        <Link to="/login" className="nav-link">
                          <i className="far fa-circle nav-icon" />
                          <p>Login v1</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link to="/register" className="nav-link">
                          <i className="far fa-circle nav-icon" />
                          <p>Register</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link to="/forgot-password" className="nav-link">
                          <i className="far fa-circle nav-icon" />
                          <p>Forgot Password</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link to="/change-password" className="nav-link">
                          <i className="far fa-circle nav-icon" />
                          <p>Recover Password</p>
                        </Link>
                      </li>
                    </ul>
                  </li>
                  {/* <li className="nav-item">
                    <Link to="#" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>
                        Login &amp; Register v2
                        <i className="fas fa-angle-left right" />
                      </p>
                    </Link>
                    <ul className="nav nav-treeview">
                      <li className="nav-item">
                        <Link to="pages/examples/login-v2.html" className="nav-link">
                          <i className="far fa-circle nav-icon" />
                          <p>Login v2</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link to="pages/examples/register-v2.html" className="nav-link">
                          <i className="far fa-circle nav-icon" />
                          <p>Register v2</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link to="pages/examples/forgot-password-v2.html" className="nav-link">
                          <i className="far fa-circle nav-icon" />
                          <p>Forgot Password v2</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link to="pages/examples/recover-password-v2.html" className="nav-link">
                          <i className="far fa-circle nav-icon" />
                          <p>Recover Password v2</p>
                        </Link>
                      </li>
                    </ul>
                  </li> */}
                  <li className="nav-item">
                    <Link to="/lockScreen" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Lockscreen</p>
                    </Link>
                  </li>
                  {/* <li className="nav-item">
                    <Link to="pages/examples/legacy-user-menu.html" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Legacy User Menu</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="pages/examples/language-menu.html" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Language Menu</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="pages/examples/404.html" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Error 404</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="pages/examples/500.html" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Error 500</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="pages/examples/pace.html" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Pace</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="pages/examples/blank.html" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Blank Page</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="starter.html" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Starter Page</p>
                    </Link>
                  </li> */}
                </ul>}
              </li>
              <li className="nav-item">
                <Link to="#" className="nav-link">
                  <i className="nav-icon fas fa-search" />
                  <p>
                    Search
                    <i className="fas fa-angle-left right" />
                  </p>
                </Link>
                <ul className="nav nav-treeview">
                  {/* <li className="nav-item">
                    <Link to="pages/search/simple.html" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Simple Search</p>
                    </Link>
                  </li> */}
                  <li className="nav-item">
                    <Link to="/Search-results" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Enhanced</p>
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-header">MISCELLANEOUS</li>
              <li className="nav-item">
                <Link to="iframe.html" className="nav-link">
                  <i className="nav-icon fas fa-ellipsis-h" />
                  <p>Tabbed IFrame Plugin</p>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="https://adminlte.io/docs/3.1/" className="nav-link">
                  <i className="nav-icon fas fa-file" />
                  <p>Documentation</p>
                </Link>
              </li>
              <li className="nav-header">MULTI LEVEL EXAMPLE</li>
              <li className="nav-item">
                <Link to="#" className="nav-link">
                  <i className="fas fa-circle nav-icon" />
                  <p>Level 1</p>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="#" className="nav-link">
                  <i className="nav-icon fas fa-circle" />
                  <p>
                    Level 1
                    <i className="right fas fa-angle-left" />
                  </p>
                </Link>
                <ul className="nav nav-treeview">
                  <li className="nav-item">
                    <Link to="#" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Level 2</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="#" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>
                        Level 2
                        <i className="right fas fa-angle-left" />
                      </p>
                    </Link>
                    <ul className="nav nav-treeview">
                      <li className="nav-item">
                        <Link to="#" className="nav-link">
                          <i className="far fa-dot-circle nav-icon" />
                          <p>Level 3</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link to="#" className="nav-link">
                          <i className="far fa-dot-circle nav-icon" />
                          <p>Level 3</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link to="#" className="nav-link">
                          <i className="far fa-dot-circle nav-icon" />
                          <p>Level 3</p>
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="nav-item">
                    <Link to="#" className="nav-link">
                      <i className="far fa-circle nav-icon" />
                      <p>Level 2</p>
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <Link to="#" className="nav-link">
                  <i className="fas fa-circle nav-icon" />
                  <p>Level 1</p>
                </Link>
              </li>
              <li className="nav-header">LABELS</li>
              <li className="nav-item">
                <Link to="#" className="nav-link">
                  <i className="nav-icon far fa-circle text-danger" />
                  <p className="text">Important</p>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="#" className="nav-link">
                  <i className="nav-icon far fa-circle text-warning" />
                  <p>Warning</p>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="#" className="nav-link">
                  <i className="nav-icon far fa-circle text-info" />
                  <p>Informational</p>
                </Link>
              </li>
            </ul>
          </nav>
          {/* /.sidebar-menu */}
        </div>
        {/* /.sidebar */}
      </aside>
    </div>
  )
}

export default SideNav
